import { render, staticRenderFns } from "./FirmSpecificDocumentCreate.vue?vue&type=template&id=7f96ede0"
import script from "./FirmSpecificDocumentCreate.vue?vue&type=script&lang=js"
export * from "./FirmSpecificDocumentCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports